module.exports = __webpack_public_path__ + "img/Process.05821e2b.svg";